import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * HopDrive employee assignments configuration.
 */
export const schema = z
  .object({
    account_manager: z
      .number()
      .int()
      .describe('Account manager user ID. Primary point of contact for day-to-day account needs.')
      .nullable()
      .optional(),
    ar_rep: z
      .number()
      .int()
      .describe('Accounts Receivable representative user ID. Handles billing inquiries and payment issues.')
      .nullable()
      .optional(),
    sales_rep: z
      .number()
      .int()
      .describe('Sales representative user ID. Primary contact for upselling and account expansion.')
      .nullable()
      .optional(),
    market_manager: z
      .number()
      .int()
      .describe('Market manager user ID. Oversees regional operations and driver relationships.')
      .nullable()
      .optional(),
  })
  .strict()
  .describe('HopDrive employee assignments. Internal team members responsible for this account relationship.');

export type HopdriveContacts = z.infer<typeof schema>;

export const definition = define({
  key: 'hopdrive_contacts',
  schema,
  label: 'HopDrive Contacts',
  description: 'HopDrive employee assignments. Internal team members responsible for this account relationship.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.HOPDRIVE_CONTACTS.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.REGION, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: {
    account_manager: null,
    ar_rep: null,
    sales_rep: null,
    market_manager: null,
  },
});
